import React from 'react';
import AuthToolbar from '../Layout/AuthToolbar'

const RoleContent = () => {
    const breadcumb = [
		{
			item: 'Home',
			path: '/'
		},
		{
			item: 'Settings',
			path: ''
		},
        {
			item: 'Roles',
			path: ''
		}
    ]
    return (
        <React.Fragment>
            <AuthToolbar 
                title='Roles'
                breadcumb = {breadcumb}
            />
        </React.Fragment>
    );
}

export default RoleContent;